export default "__VITE_ASSET__BhOnGWAO__"